import type {
  AppContext,
  AppEvents
} from "@/types/scheduling";

import { produce } from "immer";
import { AsYouType } from "libphonenumber-js";
import { assertEvent } from "xstate";

export const handleOnType = <T extends AppContext, E extends AppEvents>(context: T, event: E, params: { key: string }) => {
  assertEvent(event, "type");
  const newContext = produce(context, (draft) => {
    if (params.key === "insurance_provider_other") {
      draft.result.insurance_provider_other = event.input;
    }
    if (params.key === "lead_name") {
      draft.result.lead_name = event.input;
    }
    if (params.key === "lead_email") {
      draft.result.lead_email = event.input;
    }
    if (params.key === "lead_phone_number") {
      const formatter = new AsYouType('US');
      const formattedNumber = formatter.input(event.input);
      draft.result.lead_phone_number = formattedNumber;
    }
  });
  return newContext;
}
